import React from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  TablePagination,
  Button,
} from "@mui/material";
import { Skeleton } from "@mui/material";

const TableSkeletonRows = ({ rows = 10 }) => (
  <>
    {Array.from({ length: rows }).map((_, index) => (
      <TableRow key={index}>
        <TableCell><Skeleton width={140} /></TableCell>
        <TableCell><Skeleton width={220} /></TableCell>
        <TableCell><Skeleton width={120} height={24} /></TableCell>
        <TableCell><Skeleton width={140} /></TableCell>
        <TableCell><Skeleton width={120} height={32} /></TableCell>
      </TableRow>
    ))}
  </>
);

export const UserManagementTable = ({
  tableLoading = false,
  data = [],
  totalCount = 0,
  page = 1,
  rowsPerPage = 10,
  onPageChange,
  onRowsPerPageChange,
  onImpersonate,
}) => {
  return (
    <Box>
      <Paper sx={{ width: "100%", borderRadius: 3, boxShadow: 2, p: 2 }}>
        <TableContainer>
          <Table sx={{ minWidth: 700 }}>
          <TableHead>
              <TableRow>
                {[
                  { label: "Username", align: "left" },
                  { label: "Email", align: "center" },
                  { label: "Role", align: "center" },
                  { label: "Company", align: "center" },
                  { label: "Action", align: "center" },
                ].map((header) => (
                  <TableCell
                    key={header.label}
                    align={header.align}
                    sx={{
                      fontSize: "14px",
                      fontWeight: 600,
                      color: "#64748B",
                      borderBottom: "1px solid #E2E8F0",
                    }}
                  >
                    {header.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>

            <TableBody>
              {tableLoading ? (
                <TableSkeletonRows rows={rowsPerPage} />
              ) : data.length > 0 ? (
                data.map((row) => (
                  <TableRow
                    key={row.id}
                    hover
                    sx={{
                      cursor: "pointer",
                      "&:hover": {
                        backgroundColor: "#F8FAFC",
                      },
                    }}
                  >
                    <TableCell sx={{ fontSize: "14px", fontWeight: 400 }}>
                      {row.username}
                    </TableCell>

                    <TableCell  align="center" sx={{ fontSize: "14px" }}>
                      {row.email}
                    </TableCell>

                    <TableCell  align="center" >
                      <Chip
                        label={row.role}
                        size="small"
                        sx={{
                          fontWeight: 700,
                          fontSize: "11px",
                          backgroundColor: "#E0F2FE",
                          color: "#075985",
                        }}
                      />
                    </TableCell>

                    <TableCell  align="center" sx={{ fontSize: "14px", textTransform: "capitalize" }}>
                      {row.company_name}
                    </TableCell>

                    <TableCell  align="center">
                    <Button
                      size="small"
                      variant="outlined"
                      onClick={() => onImpersonate(row)}
                      sx={{
                        textTransform: "none",
                        fontSize: "12px",
                        borderRadius: 2,
                        minWidth: 135,
                      }}
                    >
                      Start Impersonation
                    </Button>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5} align="center" sx={{ py: 4, fontSize: "14px" }}>
                    No users found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination (unchanged) */}
        <TablePagination
          component="div"
          count={totalCount}
          page={page - 1}
          onPageChange={(e, newPage) => onPageChange(newPage + 1)}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={(e) => {
            onPageChange(1);
            onRowsPerPageChange(Number(e.target.value));
          }}
          rowsPerPageOptions={[15, 25, 50, 100]}
          sx={{
            mt: 2,
            "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
              fontSize: "12px",
              fontWeight: 600,
            },
            "& .MuiTablePagination-select": {
              fontSize: "12px",
            },
          }}
        />
      </Paper>
    </Box>
  );
};
